import { Component, ViewChild, Input, NgZone } from '@angular/core';
import { ImageService } from '../image.service';
import { mergeMap, map } from 'rxjs/operators';

@Component({
  selector: 'app-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss']
})
export class FileInputComponent {

  @Input() color = 'primary';
  @ViewChild('fileInput', { static: true }) fileInput?: any;
  @Input()
  get value() {
    return this._value;
  }
  set value(value: File | null) {
    this._value = value;
  }
  private _value: File | null = null;
  @Input()
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(value: string) {
    this._placeholder = value;
  }
  private _placeholder = '';

  constructor(
    private _imageService: ImageService,
    private _ngZone: NgZone,
  ) { }

  onClickFileInputButton() {
    this.fileInput.nativeElement.click();
  }

  onChangeFileInput() {
    const file = this.fileInput.nativeElement.files[0] as File;
    if (file) {
      const fileName = file.name;
      this._imageService.parseMetaData(file).pipe(
        mergeMap(metaData => {
          const orientation = metaData.exif ? metaData.exif.get('Orientation') : null;
          return this._imageService.getBlob(file, { orientation, canvas: true, maxWidth: 1200 });
        }),
        map((blob: any) => {
          blob.name = fileName;
          return blob;
        })
      ).subscribe({
        next: blob => this._ngZone.run(() => {
          this.value = blob as File;
        })
      });
    } else {
      this.value = null;
    }
  }

}
